import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import introimg from "../../../img/intro-img.svg";
import "./HomeIntro.css";

function HomeIntro() {
  return (
    <Container fluid className="home-intro-section">
      <Row>
        <Col sm={12} md={6} className="col-left">
          <h3 className="heading">
            Unwind, discover and release your thoughts
          </h3>
          <div className="get-started">
            <h3 className="desc">Get Started</h3>
            <Button href='/intakeform1' size="lg" variant="btn" className="intro-button">
              Talk to a Peer
            </Button>
            <br />
            <Button href='/selfevaluation' size="lg" variant="btn" className="intro-button">
              Self Evaluation
            </Button>
          </div>
        </Col>
        <Col sm={12} md={6} className="col-right">
          <img
            className="intro-img"
            src={introimg}
            alt="placeholder"
          />
        </Col>
      </Row>
    </Container>
  );
}

export { HomeIntro };
